import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import '../styles/group-detail.css';
import { DEFAULT_PERSON_IMAGE } from '../constants';
import Error from '../components/error-not-found';
import { useTranslation } from 'react-i18next';
import DataContext from '../contexts/DataContext';
import { BASE_URL } from '../constants';


const GroupDetail = () => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const achievementsPerPage = 3;
  const { t, i18n } = useTranslation('groups');
  const { groups, isLoading } = React.useContext(DataContext);


  if (isLoading) {
    return <div className="loading">{t('loading')}</div>;
  }

  const group = groups.find((group) => group.id === parseInt(id));

  if (!group) {
    return <Error />;
  }

  const totalPages = group.logros ? Math.ceil(group.logros.length / achievementsPerPage) : 0;

  const handlePrevPage = () => {
    setCurrentPage(prev => (prev > 0 ? prev - 1 : prev));
  };

  const handleNextPage = () => {
    setCurrentPage(prev => (prev < totalPages - 1 ? prev + 1 : prev));
  };

  const startIndex = currentPage * achievementsPerPage;
  const visibleAchievements = group.achievements ? group.achievements.slice(startIndex, startIndex + achievementsPerPage) : [];

  return (
    <div className="group-detail-container">
      <div className="images-gd">
        <h1>{group.name}</h1>
        {group.logo && (
          <img
            src={`${BASE_URL}images/groups/${group.logo}`}
            alt={`Imagen ${group.logo}`}
          />
        )}
        <p>{group.description}</p>
        {group.image && (
          <img
            src={`${BASE_URL}images/groups/${group.image}`}
            alt={`Imagen ${group.image}`}
          />
        )}
      </div>

      <div className="group-detail-researchArea">
        <p>{t('research-area')}: {group.area}</p>
      </div>


      <div className="achievements-section">
        {group.achievements && group.achievements.length > 0 && (
          <>
            <h2 className="achievements-heading">{t('achievements')}:</h2>
            <div className="achievements-container">
              {visibleAchievements.map((achievement, index) => (
                <div
                  className={`achievement-card ${achievement.url ? 'clickable' : ''}`}
                  key={index}
                  onClick={() => {
                    if (achievement.url) {
                      window.open(achievement.url, '_blank', 'noopener,noreferrer');
                    }
                  }}
                >
                  {achievement.foto && (
                    <div className="achievement-image-container">
                      <img
                        src={`${BASE_URL}images/groups/achievements/${achievement.foto}`}
                        alt={`Achievement ${achievement.name}`}
                        className="achievement-image"
                      />
                    </div>
                  )}
                  <div className="achievement-content">
                    <h3 className="achievement-title">{achievement.nombre}</h3>
                  </div>
                </div>
              ))}
            </div>
            {totalPages > 1 && (
              <div className="achievement-pagination">
                <button
                  className={`pagination-arrow ${currentPage === 0 ? 'disabled' : ''}`}
                  onClick={handlePrevPage}
                  disabled={currentPage === 0}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <span className="pagination-info">{currentPage + 1} / {totalPages}</span>
                <button
                  className={`pagination-arrow ${currentPage === totalPages - 1 ? 'disabled' : ''}`}
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages - 1}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {group.socialMedia && (
        <h2 className="redes-heading">{t('social-media')}:</h2>
      )}
      <div className="social-media-group">
        {group.website && (
          <a href={group.website} target='_blank' rel="noopener noreferrer" className="social-links web"><i className="bi bi-globe"></i><span>{group.website}</span></a>
        )}
        {group.socialMedia.correo && (
          <a href={`mailto:${group.socialMedia.correo}`} target='_blank' rel="noopener noreferrer" className="social-links email"><i className="bi bi-envelope"></i><span>{group.socialMedia.correo}</span></a>
        )}
        {group.github && (
          <a href={group.github} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-github"></i><span>{group.github}</span></a>
        )}
        {group.socialMedia.instagram && (
          <a href={group.socialMedia.instagram} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-instagram"></i><span>{group.socialMedia.instagram}</span></a>
        )}
        {group.socialMedia.tiktok && (
          <a href={group.socialMedia.tiktok} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-tiktok"></i><span>{group.socialMedia.tiktok}</span></a>
        )}
        {group.socialMedia.youtube && (
          <a href={group.socialMedia.youtube} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-youtube"></i><span>{group.socialMedia.youtube}</span></a>
        )}
        {group.socialMedia.facebook && (
          <a href={group.socialMedia.facebook} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-facebook"></i><span>{group.socialMedia.facebook}</span></a>
        )}
        {group.socialMedia.whatsapp && (
          <a href={group.socialMedia.whatsapp} target='_blank' rel="noopener noreferrer" className="social-links"><i className="bi bi-whatsapp"></i><span>{group.socialMedia.whatsapp}</span></a>
        )}
      </div>
    </div>
  );
};

export default GroupDetail;